module.exports = __webpack_public_path__ + "static/media/Map_2.18a2e63e.png";